import {Component, Injector} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {getTranslation} from 'shared/helpers/get-translation';

import {QuestionPage} from '../../components/question-page/question-page';
import {Rating} from '../../model/model';
import { NavService } from 'shared/nav/nav.service';

@Component({
  selector: 'rating-page',
  templateUrl: 'rating-page.html',
  styleUrls: ['rating-page.scss'],
  host: { '[class]': '"ion-page can-go-back"' },
})
export class RatingPage extends QuestionPage {

  public selections: Array<string>;
  public value: number = 0;
  public minLabel: string;
  public maxLabel: string;

  public get isValid(): boolean {
    return this.value > 0;
  }

  constructor(
    private translateService: TranslateService,
    private injector: Injector,
    public navService: NavService,
  ) {
    super(injector, navService);

    if (!this.question) {
      return;
    }

    const rating: Rating = <Rating> this.question.type;
    this.minLabel = getTranslation(rating.minText, this.translateService);
    this.maxLabel = getTranslation(rating.maxText, this.translateService);
  }

  public onNextClick(): void {
    this.answerSelected.emit(this.value);
  }

  public onGoalClick(): void {
    this.answerAsGoal.emit(this.value);
  }
}
